module.exports = __webpack_public_path__ + "static/media/panda.68b0b089.svg";